import * as React from 'react';
import classnames from 'classnames';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import styles from './AccordionTitle.styl';
const AccordionTitle = ({ title, opened }) => {
    const iconProps = {
        customDimensions: true,
        className: classnames(styles.icon, { [styles.opened]: opened }),
        name: 'arrowSearchAccordionBlue',
        width: '12',
        height: '12'
    };
    return (React.createElement("div", { className: styles.AccordionTitle },
        React.createElement("span", null, title),
        React.createElement(IconSVG, { ...iconProps })));
};
export default AccordionTitle;
